@if (service.active$ | async; as vm) {
  <mat-card
    class="supademo-card mat-elevation-z8"
    [style.--tour-popover-color]="vm.accentColor || null"
    [ngClass]="{
      'pos-bottom': vm.placement === 'bottom',
      'pos-top': vm.placement === 'top',
      'pos-right': vm.placement === 'right',
      'pos-left': vm.placement === 'left',
      'pos-center': vm.placement === 'center' || vm.placement === 'auto',
    }"
  >
    <!-- Close (X) -->
    @if (vm.showClose) {
      <button type="button" mat-icon-button class="close-btn" aria-label="Close" (click)="service.requestExitViaCloseButton()">
        <mat-icon>close</mat-icon>
      </button>
    }

    <!-- Beacon & Arrow -->
    @if (vm.showBeacon) {
      <div class="beacon"></div>
    }
    <div
      class="arrow"
      [ngClass]="{
        'arrow-top': vm.placement === 'bottom',
        'arrow-bottom': vm.placement === 'top',
        'arrow-left': vm.placement === 'right',
        'arrow-right': vm.placement === 'left',
      }"
    ></div>

    <div class="content-wrapper">
      @if (vm.title) {
        <div class="title" [innerHTML]="vm.title"></div>
      }
      <div class="tour-body" [innerHTML]="vm.message"></div>

      <div class="footer">
        <div class="progress">{{ vm.idx + 1 }} of {{ vm.total }}</div>
        <span class="spacer"></span>
        @if (vm.showPrev) {
          <button type="button" mat-icon-button class="nav-btn" (click)="service.prev()" aria-label="Back">
            <mat-icon>arrow_back</mat-icon>
          </button>
        }
        <!-- Next (hidden on last step or when step.hideNext=true) -->
        @if (vm.showNext) {
          <button type="button" mat-icon-button class="nav-btn primary" (click)="service.next()" aria-label="Next">
            <mat-icon>arrow_forward</mat-icon>
          </button>
        }

        <!-- Finish (only on last step) -->
        @if (vm.showFinish) {
          <button type="button" mat-icon-button class="nav-btn primary finish" (click)="service.finish(true, true)" aria-label="Finish">
            <mat-icon>done</mat-icon>
          </button>
        }
      </div>
    </div>
  </mat-card>
}
